import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed } from "@nuxtjs/composition-api";

import { useVuetify } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkGrid',
  props: {
  /**
   * Array of ltk id strings, and the relative order they should be rendered
   *
   */
  items: {
    type: Array as PropType<string[]>,
    required: true,
    default: () => [],
  },
  /**
   * Alias of fetchState from the providing page
   */
  fetchState: {
    type: Object as PropType<Vue["$fetchState"]>,
    required: true,
  },
  /**
   * Number of columns to render based on breakpoint name.
   */
  xsColumns: {
    type: Number,
    default: 6,
  },
  smColumns: {
    type: Number,
    default: 4,
  },
  mdColumns: {
    type: Number,
    default: 4,
  },
  lgColumns: {
    type: Number,
    default: 3,
  },
  xlColumns: {
    type: Number,
    default: 3,
  },
  columnClass: {
    type: String as PropType<string | undefined>,
    default: undefined,
  },
  hasNextPage: {
    type: Boolean,
    default: false,
  },
  dense: {
    type: Boolean as PropType<boolean | undefined>,
    default: undefined,
  },
},
  emits: ["page"],
  setup(__props, { emit }: { emit: ({
  (e: "page"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const vuetify = useVuetify();





/**
 * Handler for pagination intersection elements
 */
const handlePagination = ([entry]: IntersectionObserverEntry[]) => {
  if (entry.isIntersecting) {
    emit("page");
  }
};

const isDense = computed(() => props.dense ?? vuetify.breakpoint.xsOnly);

return { __sfc: true,vuetify, props, emit, handlePagination, isDense }
}

})